import styled, { css } from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

import { Text, Flex, Button } from 'Components/UI'

export const ModalContent = styled(Flex).attrs({
  width: ['100%', '500px'],
})`
  align-items: center;
  justify-content: space-between;
  flex-direction: column;
`

export const ModalText = styled(Text).attrs({
  fontSize: 2,
  mt: 3,
})`
  color: ${themeGet('colors.boulder')};
  line-height: 1.5;
  width: 100%;
`

const roundedborderButtonCss = ({ roundedborder }) =>
  roundedborder &&
  css`
    border-radius: ${themeGet('borderRadius.2')} !important;
    overflow: hidden;
  `

export const ModalButton = styled(Button).attrs({
  fontSize: 2,
  mt: [32, 45],
})`
  color: ${({ color }) => color || themeGet('colors.font.secondary')};
  background-color: ${({ background }) =>
    background || themeGet('colors.goldenrod')};
  border-radius: ${themeGet('borderRadius.1')};
  font-weight: 700;
  text-transform: uppercase;

  align-items: center;
  display: flex;
  justify-content: center;
  height: 48px;
  width: 150px;

  ${roundedborderButtonCss};
`
